import Vue from 'vue'
import Router from 'vue-router'
import First from '@/views/First'
import { adminAPI }  from '@/assets/js/api.js';

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'First',
      component: First
    },
    {
      path: '/Login',
      name: 'Login',
      component: () => import('@/views/Login'),
    },
    {
      path: '/ForgotPassword',
      name: 'ForgotPassword',
      component: () => import('@/views/ForgotPassword'),
    },
    {
      path: '/Dashboard',
      name: 'Dashboard',
      component: () => import('@/views/Dashboard'),
    },
    {
      path: '/Products',
      name: 'Products',
      component: () => import('@/views/Products'),
    },
    {
      path: '/Product/:productId',
      name: 'Product',
      component: () => import('@/views/Product'),
    },
    {
      path: '/Doctors',
      name: 'Doctors',
      component: () => import('@/views/Doctors'),
    },
    {
      path: '/Doctor/Add',
      name: 'AddDoctor',
      component: () => import('@/views/AddDoctor'),
    },
    {
      path: '/Doctor/View/:doctorId',
      name: 'ViewDoctor',
      component: () => import('@/views/ViewDoctor'),
    },
    {
      path: '/Reps',
      name: 'Reps',
      component: () => import('@/views/Reps'),
    },
    {
      path: '/Rep/:repId',
      name: 'Rep',
      component: () => import('@/views/Rep'),
    }
  ]
});

router.beforeEach((to, from, next) => {
  //get company details
  adminAPI.getCompanies().then((response) => {
    if(!response){
      alert('Please contact the administrator to set up the company');
      return next('/');
    }
  });

  //redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/Login', '/', '/ForgotPassword'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = sessionStorage.getItem('token');
  const twoFA = sessionStorage.getItem('twoFA');

  if (authRequired && !loggedIn && !twoFA) {
    return next('/Login');
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js